interface FiatCurrencyImageProps {
  iso: string;
  name?: string;
  size?: number;
  className?: string;
}

export function FiatCurrencyImage({
  iso,
  name,
  size = 20,
  className,
}: FiatCurrencyImageProps) {
  if (!iso) return null;

  return (
    <img
      src={`https://flagcdn.com/w40/${iso.toLowerCase()}.png`}
      alt={name ?? iso}
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: "cover",
        borderRadius: 2,
      }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  );
}
